import {
  BILLING_DETAILS,
  INVOICES,
  LOADING,
  PRICING_DETAILS,
  PRICING_LOADING,
} from "../actionType/paymentType";
import {
  billingDetails,
  createPayment,
  pricingCalculate,
  paymentsHistory,
  verifyPayment,
} from "../constant/Constant";
import {
  getAuthMethod,
  patchAuthMethod,
  postAuthMethod,
} from "../services/HttpServices";

export const createBillingDetails = (payload) => (dispatch) => {
  return postAuthMethod(billingDetails, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getBillingDetails = (id) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  return getAuthMethod(billingDetails)
    .then((res) => {
      dispatch({
        type: BILLING_DETAILS,
        payload: res.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: BILLING_DETAILS,
        payload: [],
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const updateBillingDetails = (payload) => (dispatch) => {
  return patchAuthMethod(billingDetails, payload?.id, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const purchasePlan = (payload) => (dispatch) => {
  return postAuthMethod(createPayment, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const verifyPlanPayment = (payload) => (dispatch) => {
  return postAuthMethod(verifyPayment, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getPaymentHistory = (id) => (dispatch) => {
  dispatch({
    type: LOADING,
    payload: true,
  });

  return getAuthMethod(paymentsHistory)
    .then((res) => {
      dispatch({
        type: INVOICES,
        payload: res.data,
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: INVOICES,
        payload: [],
      });
      dispatch({
        type: LOADING,
        payload: false,
      });
      return err;
    });
};

export const calculatePricing = (payload) => (dispatch) => {
  dispatch({
    type: PRICING_LOADING,
    payload: true,
  });

  return postAuthMethod(pricingCalculate, payload)
    .then((res) => {
      dispatch({
        type: PRICING_DETAILS,
        payload: res.data,
      });
      dispatch({
        type: PRICING_LOADING,
        payload: false,
      });
      return res;
    })
    .catch((err) => {
      dispatch({
        type: PRICING_DETAILS,
        payload: null,
      });
      dispatch({
        type: PRICING_LOADING,
        payload: false,
      });
      return err;
    });
};
